import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import TextHelper from '@/core/helpers/TextHelper';
import buildings from '../schedule/getExamsUseCase/buildings.json';
import {
  ICourseExam,
  ISectionExamRolProps
} from '@/presentation/modules/home/modules/examRol/components/types';
import { extractCampusAndSede } from '../schedule/getExamsUseCase/saga';
import ExamsRoleByStudentRepository from '@/domain/repositories/ExamsRoleByStudentRepository';
import ExamsRoleByStudentDataRepository from '@/data/repositories/ExamsRoleByStudentRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* getExamsRoleByStudent(): any {
  try {
    yield put({ type: Types.GET_EXAMS_ROLE_BY_STUDENT_REQUEST });

    XCheckpointManager.registerStart('Rol de exámenes');
    const examsRoleByStudent: ExamsRoleByStudentRepository =
      new ExamsRoleByStudentDataRepository();

    const { academic } = yield select((state: any) => state?.profile?.data);
    // const { current_utp_period: currentPeriod } = yield select(
    //   (state: any) => state?.externalSettings?.data
    // );
    const { data: dataPeriods } = yield select(
      (state: any) => state.getPeriods
    );
    const currentPeriod = dataPeriods?.find((p: any) => !!p.isCurrent);

    const examsRoleByStudentResponse = yield call(
      examsRoleByStudent.getExamsRoleByStudent,
      academic?.career ?? '',
      currentPeriod?.period ?? ''
    );

    if (!examsRoleByStudentResponse)
      throw new Error('No se encontraron examenes');

    const getInformationBuilding = (codCampus?: string, classRoom?: string) => {
      if (!codCampus) return {};
      const buildingInformation = buildings.find(
        (building) => building.id === codCampus
      );
      const { campus, sede } = extractCampusAndSede(
        buildingInformation?.description ?? ''
      );
      // get floor and pavilion from classRoom
      const pavilion = classRoom?.substring(0, 1);
      const floor = classRoom?.substring(1, 3);

      return {
        campus: campus ?? '-',
        sede: sede ?? '-',
        pavilion: pavilion ?? '-',
        floor: floor ?? '-',
        address: buildingInformation?.address ?? '-',
        lat: buildingInformation?.coordinates?.latitude ?? 0,
        long: buildingInformation?.coordinates?.longitude ?? 0
      };
    };

    const mapExamsRoleByStudent: ISectionExamRolProps = Object.fromEntries(
      Object.entries(examsRoleByStudentResponse).map(([key, exams]) => [
        key,
        (exams as any[])?.map((exam: any) => ({
          ...exam,
          courses: exam.courses?.map((examCourse: any): ICourseExam => {
            const { campus, pavilion, floor, sede, address, lat, long } =
              getInformationBuilding(
                examCourse?.location?.campus,
                examCourse?.location?.classroom
              );
            return {
              ...examCourse,
              name: TextHelper.capitalize(examCourse?.name ?? '', false, true),
              location: examCourse?.location
                ? {
                    ...examCourse.location,
                    campus,
                    pavilion,
                    floor,
                    sede,
                    address,
                    lat,
                    long
                  }
                : null
            };
          })
        })) || []
      ])
    );

    yield put({
      type: Types.GET_EXAMS_ROLE_BY_STUDENT_CLEAR
    });
    yield put({
      type: Types.GET_EXAMS_ROLE_BY_STUDENT_SUCCESS,
      data: mapExamsRoleByStudent
    });
    XCheckpointManager.registerEnd('Rol de exámenes');
  } catch (error) {
    yield put({
      type: Types.GET_EXAMS_ROLE_BY_STUDENT_FAILURE,
      error: 'Ocurrió un error al obtener los examenes del alumno.'
    });
    XCheckpointManager.registerEnd('Rol de exámenes');
  }
}
